export default "__VITE_ASSET__B6CvvG2R__"